<template>
	<div>
		<el-drawer :modal="false" title="Net Income" :visible.sync="drawerViewNetIncomeDetails"
			class="drawer-view-net-income-details" size="45%">
			<b-container>
				<b-row class="mb-4 align-items-center">
					<b-col cols="6">
						<b-form-group label="Working Country">
							<el-select v-model="form.working_country" placeholder="Select" filterable>
								<el-option :label="country.name" :value="country.name" v-for="(country, index) in countries"
									:key="index"></el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<b-col cols="6" v-if="!_gHlp.isEmpty(form.working_country) && (form.working_country != 'Malaysia')">
						<b-form-group :label="'Currency ' + curency + ' to MYR'">
							<CurrencyInput v-model="form.foreign_currency"
								:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
						</b-form-group>
					</b-col>
				</b-row>
				<b-row class="mb-4 align-items-center">
					<b-col>
						<span>Total</span>
						<div class="d-flex align-items-center">
							<h2 v-if="!_gHlp.isEmpty(form.working_country) && (form.working_country != 'Malaysia')" class="mb-0 mr-3">
								{{ curency }} {{ totalNetIncomeSGD | moneyFormatter }} <small>/</small> RM {{ totalNetIncomeRYM |
									moneyFormatter }}
							</h2>
							<h2 v-else class="mb-0 mr-3">RM {{
								parseFloat(_gHlp.getValue(current_customer, 'incomes.main.net_income', 0)).toLocaleString(undefined,
									{ minimumFractionDigits: 2 }) }}</h2>
							<el-button type="text" @click="toggleDetailsModal">View Details</el-button>
						</div>
					</b-col>
					<!-- <b-col>
                        <b-button variant="primary" class="float-right">View Commitment</b-button>
                    </b-col> -->
				</b-row>

				<ValidationObserver v-slot="{ invalid }" ref="observer">
					<b-form role="form" class="mt-4">
						<b-row>
							<b-col cols="8">
								<b-form-group label="I am">
									<el-select v-model="form.income_type_id" placeholder="Select" change="selectIncome">
										<el-option :label="income_type.name" :value="income_type.income_type_id"
											v-for="income_type in tables.income_types" :key="income_type.income_type_id"></el-option>
									</el-select>
								</b-form-group>
							</b-col>

							<b-col cols="8">
								<b-form-group label="I earn" v-if="show.iearn">
									<el-select v-model="form.income_earn_type_id" placeholder="Select" change="selectIncome">
										<el-option :label="income_earn_type.name" :value="income_earn_type.income_earn_type_id"
											v-for="income_earn_type in tables.income_earn_types"
											:key="income_earn_type.income_earn_type_id"></el-option>
									</el-select>
								</b-form-group>
							</b-col>

							<b-col cols="8" v-if="show.salary">
								<b-form-group label="Gross Income">

									<div class="row" v-if="isForeigIncome">
										<b-input-group size="md" prepend="SGD" class="col-md-6">
											<b-form-input v-model="form.gross_income" type="number" step="0.01" class="bg-white" disabled></b-form-input>
										</b-input-group>
										<b-input-group size="md" prepend="RM" class="col-md-6">
											<b-form-input :value="foreign_income" type="number" step="0.01" class="bg-white"
												disabled></b-form-input>
										</b-input-group>
									</div>
									<div class="row" v-else>
										<b-input-group size="md" prepend="RM" class="col-md-12">
											<b-form-input v-model="form.gross_income" type="number" step="0.01" class="bg-white" disabled></b-form-input>
										</b-input-group>
									</div>

								</b-form-group>
							</b-col>

							<b-col cols="8" v-if="show.salary">
								<b-form-group label="Salary (Monthly)">

									<div class="row" v-if="isForeigIncome">
										<b-input-group size="md" prepend="SGD" class="col-md-6">
											<b-form-input v-model="form.salary" type="number" step="0.01"></b-form-input>
										</b-input-group>
										<!-- <b-input-group size="md" prepend="RM" class="col-md-6">
											<b-form-input :value="forign_salary" type="number" step="0.01" class="bg-white" disabled></b-form-input>
										</b-input-group> -->
									</div>
									<div class="row" v-else>
										<b-input-group size="md" prepend="RM" class="col-md-12">
											<b-form-input v-model="form.salary" type="number" step="0.01"></b-form-input>
										</b-input-group>
									</div>

								</b-form-group>
							</b-col>

							<b-col cols="8" v-if="show.fixed_allowance">
								<b-form-group label="Fixed Allowance">
									<!-- <el-checkbox v-model="form.epf_excluded_fa" class="mb-3">Exclude CPF</el-checkbox> -->
									<CurrencyInput v-model="form.fixed_allowance" :options="currencyOptions" />
								</b-form-group>
							</b-col>


							<b-col cols="8">
								<b-form-group>
									<label>
										Company Type
									</label>
									<div class="d-flex flex-wrap">
										<b-form-radio v-model="form.company_type" name="companyType" value="MNC" class="mr-3">
											MNC
										</b-form-radio>
										<b-form-radio v-model="form.company_type" name="companyType" value="GLC" class="mr-3">
											GLC
										</b-form-radio>
										<b-form-radio v-model="form.company_type" name="companyType" value="PLC" class="mr-3">
											PLC
										</b-form-radio>
										<b-form-radio v-model="form.company_type" name="companyType" value="Sdn Bhd" class="mr-3">
											Sdn Bhd
										</b-form-radio>
										<b-form-radio v-model="form.company_type" name="companyType" value="Sole Proprietor or Partnership"
											class="mr-3">
											Sole Proprietor or Partnership
										</b-form-radio>
										<b-form-radio v-model="form.company_type" name="companyType" value="Non MNC" class="mr-3">
											Non MNC
										</b-form-radio>
									</div>
								</b-form-group>
							</b-col>
							<!-- <b-col cols="8" class="mb-3">
                                <b-button block variant="primary" class="w-50" @click.prevent="updateMainIncome()" :disabled="invalid">Save</b-button>
                            </b-col> -->

							<!-- Variable Income -->
							<b-col cols="12">
								<div class="accordion bonus-accordion">
									<b-form-checkbox v-model="form.var_income" :disabled="disableVarIncome" name="checkbox-toggle"
										class="py-3">
										<h3>Variable Income</h3>
									</b-form-checkbox>
									<b-collapse v-model="form.var_income">
										<VariableIncome :main_form.sync="form" :customer.sync="current_customer"
											:show_contribution.sync="show_contribution" :currency-options="currencyOptions"
											@income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Commission -->
							<b-col cols="12">
								<div class="accordion bonus-accordion">
									<b-form-checkbox v-model="form.commission" :disabled="disableCommission" name="checkbox-toggle"
										class="py-3">
										<h3>Commission</h3>
									</b-form-checkbox>
									<b-collapse v-model="form.commission">
										<Commission :main_form.sync="form" :customer.sync="current_customer"
											:currency-options="currencyOptions" @income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Business Income -->
							<b-col cols="12">
								<div class="accordion bonus-accordion">
									<b-form-checkbox v-model="form.bizIncome" :disabled="disableBizIncome" name="checkbox-toggle"
										class="py-3">
										<h3>Business Income</h3>
									</b-form-checkbox>
									<b-collapse v-model="form.bizIncome">
										<BusinessIncome :main_form="form" :customer.sync="current_customer" :tables="tables"
											:currency-options="currencyOptions" @income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Bonus -->
							<b-col cols="12">
								<div class="accordion bonus-accordion">
									<b-form-checkbox v-model="bonusChecked" :disabled="disableBonus" name="checkbox-toggle" class="py-3">
										<h3>Bonus</h3>
									</b-form-checkbox>
									<b-collapse v-model="bonusChecked">
										<BonusIncome :main_form="form" :customer.sync="current_customer" :currency-options="currencyOptions"
											@income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Monthly Rental Income -->
							<b-col cols="12">
								<div class="accordion rental-income">
									<b-form-checkbox v-model="rentalChecked" name="checkbox-toggle" class="py-3">
										<h3>Monthly Rental Income</h3>
									</b-form-checkbox>
									<b-collapse v-model="rentalChecked">
										<RentalIncome :main_form="form" :customer.sync="current_customer" :tables="tables"
											@income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Monthly Other Income -->
							<b-col cols="12">
								<div class="accordion other-income">
									<b-form-checkbox v-model="otherChecked" name="checkbox-toggle" class="py-3">
										<h3>Monthly Other Income</h3>
									</b-form-checkbox>
									<b-collapse v-model="otherChecked">
										<OtherIncome :main_form="form" :customer.sync="current_customer"
											@income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Deduction -->
							<b-col cols="12">
								<div class="accordion deduction">
									<b-form-checkbox v-model="deductionChecked" :disabled="disabledDeduction" name="checkbox-toggle"
										class="py-3">
										<h3>Deduction</h3>
									</b-form-checkbox>
									<b-collapse v-model="deductionChecked">
										<TaxDeduction :main_form="form" :customer.sync="current_customer"
											@income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>
						</b-row>
						<b-row class="mt-1 pt-4 pb-5">
							<b-col cols="4">
								<el-button class="bg-primary text-white w-100" @click.prevent="updateAll()"
									:loading="is_loading">Save</el-button>
							</b-col>
						</b-row>
					</b-form>
				</ValidationObserver>
			</b-container>
		</el-drawer>
		<!-- Modal View  -->
		<modal :show.sync="modals.view_income_details" modalClasses="drawer-view-net-income-modal">
			<h6 slot="header" class="modal-title">Net Income Details</h6>
			<table-net-income-details :customer.sync="current_customer" :main_form="form"
				:currency="curency"></table-net-income-details>
			<div slot="footer"></div>
		</modal>
	</div>
</template>
<script>
import { Drawer, Button, RadioGroup, RadioButton, Checkbox, Collapse, CollapseItem, Form, FormItem, Select, Option } from 'element-ui'
import BonusIncome from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/BonusIncome'
import RentalIncome from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/RentalIncome'
import OtherIncome from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/OtherIncome'
import VariableIncome from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/VariableIncome'
import Commission from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/Commission'
import BusinessIncome from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/BusinessIncome'
import TaxDeduction from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/TaxDeduction'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import TableNetIncomeDetails from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/TableNetIncomeDetails'
import {
	notifyFunctionMixin,
	helperFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { EventBus } from '@/main'
import CurrencyInput from '@/components/CurrencyInput'
import { COUNTRIES_CURRENCY } from '@/assets/js/options.js'

export default {
	name: 'drawer-view-net-income-details',
	components: {
		CurrencyInput,
		ValidationObserver,
		[Drawer.name]: Drawer,
		[Button.name]: Button,
		[RadioGroup.name]: RadioGroup,
		[RadioButton.name]: RadioButton,
		[Checkbox.name]: Checkbox,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
		[Form.name]: Form,
		[FormItem.name]: FormItem,
		[Select.name]: Select,
		[Option.name]: Option,
		VariableIncome,
		Commission,
		BusinessIncome,
		BonusIncome,
		RentalIncome,
		OtherIncome,
		TableNetIncomeDetails,
		TaxDeduction
	},
	mixins: [
		helperFunctionMixin,
		notifyFunctionMixin
	],
	data() {
		return {
			is_loading: false,
			mainForm: {},
			show_contribution: false,
			drawerViewNetIncomeDetails: false,
			form: {
				income_type_id: '',
				income_earn_type_id: '',
				salary: '',
				fixed_allowance: '',
				var_income: false,
				commission: false,
				bizIncome: false,
				total_rental_income: '',
				total_other_income: '',
				epf_excluded_fa: false,
				company_type: '',
				working_country: '',
				foreign_currency: '',
				foreign_income: '',
			},
			show: {
				salary: true,
				fixed_allowance: true,
				iearn: false
			},
			bonusChecked: false,
			rentalChecked: false,
			otherChecked: false,
			deductionChecked: false,
			disabledDeduction: true,
			disableVarIncome: true,
			disableCommission: true,
			disableBonus: true,
			disableBizIncome: true,
			tables: [],
			modals: {
				view_income_details: false
			},
			countries: COUNTRIES_CURRENCY
		};
	},

	async created() {
		this.$watch(
			() => this.current_customer,
			(newVal) => {
				if (newVal) {
					this.rentalChecked = newVal.incomes.rental.length > 0
					this.bonusChecked = newVal.incomes.bonus.length > 0
					this.otherChecked = newVal.incomes.other.length > 0
					this.deductionChecked = newVal.incomes.other_tax_deduction?.length > 0 || newVal.incomes.main.tax_deduction > 0 || newVal.incomes.main.ndi_deduction > 0

					const { income_type_id, income_earn_type_id, monthly_salary, fixed_allowance, gross_income } = newVal.incomes.main
					this.form.working_country = _gHlp.getValue(this.current_customer, 'incomes.main.working_country', 'Malaysia')
					this.form.foreign_currency = _gHlp.getValue(this.current_customer, 'incomes.main.foreign_currency', 0)
					this.form.income_type_id = income_type_id ?? ""
					this.form.income_earn_type_id = income_earn_type_id ?? ""
					this.form.salary = (this.isForeigIncome) ? _gHlp.currencyFromRM(monthly_salary ?? 0, this.form.foreign_currency) : (monthly_salary ?? 0)
					this.form.fixed_allowance = (this.isForeigIncome) ? _gHlp.currencyFromRM(fixed_allowance ?? 0, this.form.foreign_currency) : (fixed_allowance ?? 0)
					this.form.company_type = this.current_customer.companies?.current?.company_type ?? null
					this.form.gross_income = (this.isForeigIncome) ? _gHlp.currencyFromRM(gross_income ?? 0, this.form.foreign_currency) : (gross_income ?? 0)

					if (this.form.income_type_id === 2) {
						this.form.bizIncome = newVal.incomes.business.length > 0 || newVal.incomes.main.income_type_id === 2
					}

					this.form.commission = newVal.incomes.commission.length > 0

					if (![2, 4].includes(this.form.income_type_id)) {
						this.form.var_income = newVal.incomes.variable.length > 0
					}
				}
			},
			{ immediate: true }
		)
	},
	watch: {
		'form.income_earn_type_id': {
			handler: function (newValue) {
				switch (newValue) {
					case 1:
						this.form.var_income = false
						this.disableVarIncome = true;
						this.form.commission = false
						this.disableCommission = true;
						break;
					case 2:
						this.form.var_income = true
						this.disableVarIncome = false;
						this.form.commission = false
						this.disableCommission = true;
						break;
					case 3:
						this.form.var_income = true
						this.disableVarIncome = false;
						this.form.commission = true
						this.disableCommission = false;
						break;
				}
			},
			immediate: true
		},
		'form.income_type_id': {
			handler: function (newValue) {
				switch (newValue) {
					case 1:
						this.show_contribution = false
						this.show.salary = true;
						this.show.fixed_allowance = true;
						this.disableBonus = false;
						this.disabledDeduction = false;
						this.disableBizIncome = true
						this.form.bizIncome = false
						this.show.iearn = true
						if (this.form.income_earn_type_id === 1) {
							this.form.var_income = false
							this.disableVarIncome = true;
							this.form.commission = false
							this.disableCommission = true;
						}
						if (this.form.income_earn_type_id === 2) {
							this.form.var_income = true
							this.disableVarIncome = false;
							this.form.commission = false
							this.disableCommission = true;
						}
						if (this.form.income_earn_type_id === 3) {
							this.form.var_income = true
							this.disableVarIncome = false;
							this.form.commission = true
							this.disableCommission = false;
						}
						break;
					case 2:
						this.show_contribution = false
						this.show.salary = false;
						this.show.fixed_allowance = false;
						this.form.var_income = false;
						this.disableVarIncome = true;
						this.form.commission = false;
						this.disableCommission = true;
						this.disableBonus = true;
						this.disabledDeduction = true
						this.disableBizIncome = false
						this.form.bizIncome = true
						this.show.iearn = false
						break;
					case 3:
						this.show_contribution = true
						this.show.salary = true;
						this.show.fixed_allowance = true;
						this.disableVarIncome = false;
						this.disableCommission = true;
						this.disableBonus = false;
						this.disabledDeduction = false
						this.disableBizIncome = true
						this.form.bizIncome = false
						this.show.iearn = false
						break;
					case 4:
						this.show_contribution = false
						this.show.salary = false;
						this.show.fixed_allowance = false;
						this.disableVarIncome = true;
						this.form.var_income = false;
						this.disableCommission = false
						this.disableBonus = false;
						this.disabledDeduction = true
						this.disableBizIncome = true
						this.form.bizIncome = false
						this.show.iearn = false
						break;
					case 5:
						this.show_contribution = true
						this.show.salary = true;
						this.show.fixed_allowance = true;
						this.disableVarIncome = false;
						this.disableCommission = true;
						this.disableBonus = false;
						this.disabledDeduction = false
						this.disableBizIncome = true
						this.form.bizIncome = false
						this.show.iearn = false
						break;
					default:
						this.disableVarIncome = true;
						this.disableCommission = true;
						this.disableBonus = false;
						this.disabledDeduction = true
						this.disableBizIncome = true
						this.show.iearn = false
				}
			},
			immediate: true
		},
		async drawerViewNetIncomeDetails(newVal) {
			if (newVal === true && this.tables.length === 0) {
				this.tables = await this.getLookupTables([
					'housing_types',
					'iff_codes',
					'income_types',
					'income_earn_types',
				])
			}
		}
	},

	computed: {
		...mapState(useCustomerStore, ['current_customer']),
		totalNetIncomeRYM() {
			let payslip_other_deduction = this.getPaySlipOtherDeduction();
			const gross_income = _gHlp.getValue(this.current_customer, 'incomes.main.gross_income', 0);
			const bonus_income = _gHlp.getValue(this.current_customer, 'incomes.main.av_bonus_inc', 0);
			const rental_income = _gHlp.getValue(this.current_customer, 'incomes.main.total_rental_inc', 0);
			const other_income = _gHlp.getValue(this.current_customer, 'incomes.main.total_other_inc', 0);
			const total = parseFloat(gross_income) - payslip_other_deduction + parseFloat(rental_income) + parseFloat(other_income) + parseFloat(bonus_income);
			parseFloat(total.toFixed(2))
			return parseFloat(total.toFixed(2));
		},

		totalNetIncomeSGD() {
			let payslip_other_deduction = this.getPaySlipOtherDeduction();
			payslip_other_deduction = _gHlp.currencyFromRM(
				payslip_other_deduction,
				this.form.foreign_currency
			);
			const gross_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.current_customer, 'incomes.main.gross_income', 0),
				this.form.foreign_currency
			);
			const bonus_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.current_customer, 'incomes.main.av_bonus_inc', 0),
				this.form.foreign_currency
			);
			const rental_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.current_customer, 'incomes.main.total_rental_inc', 0),
				this.form.foreign_currency
			);
			const other_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.current_customer, 'incomes.main.total_other_inc', 0),
				this.form.foreign_currency
			);
			const socso = _gHlp.getValue(this.current_customer, 'incomes.main.sosco', 0);
			const epf = _gHlp.getValue(this.current_customer, 'incomes.main.epf', 0);
			const incomeTax = _gHlp.getValue(this.current_customer, 'incomes.main.income_tax', 0);
			if (!this.isForeigIncome) {
				const net_income = _gHlp.getValue(this.current_customer, 'incomes.main.net_income', 0);
				const total = parseFloat(net_income) + parseFloat(socso) + parseFloat(epf) + parseFloat(incomeTax);
				return parseFloat(total.toFixed(2));
			}
			const total = this.checkNum(gross_income) - this.checkNum(payslip_other_deduction) +
				this.checkNum(rental_income) + this.checkNum(other_income) + this.checkNum(bonus_income);
			return parseFloat(total.toFixed(2));
		},

		isForeigIncome() {
			return !_gHlp.isEmpty(this.form.working_country) && (this.form.working_country != 'Malaysia')
		},
		curency() {
			const ctry = this.countries.find(o => o.name == this.form.working_country)
			return _gHlp.getValue(ctry, 'currency', 'MYR');
		},
		forign_salary() {
			return (this.isForeigIncome) ? _gHlp.currencyToRM(this.form.salary ?? 0, this.form.foreign_currency) : (this.form.salary ?? 0)
		},
		foreign_income() {
			return (this.isForeigIncome) ? _gHlp.currencyToRM(this.form.gross_income ?? 0, this.form.foreign_currency) : (this.form.gross_income ?? 0)
		},
		currencyOptions() {
			return {
				currency: this.isForeigIncome ? 'SGD' : 'MYR',
				currencyDisplay: this.isForeigIncome ? 'symbol' : 'hidden',
				autoDecimalDigits: true,
			};
		},

	},
	methods: {
		...mapActions(useCustomerStore, ['getCustomer']),
		collectedIncomeData(newData) {
			this.mainForm = Object.assign(this.mainForm, newData);
		},
		getPaySlipOtherDeduction() {
			let payslip_other_deduction = 0;
			const oth = _gHlp.getValue(this.current_customer, 'incomes.main.total_other_deduction', 0);
			const ndi = _gHlp.getValue(this.current_customer, 'incomes.main.ndi_deduction', 0);
			const tax = _gHlp.getValue(this.current_customer, 'incomes.main.tax_deduction', 0);
			if (!this.isForeigIncome) {
				payslip_other_deduction = oth;
			} else {
				payslip_other_deduction = parseFloat(oth) + parseFloat(ndi) + parseFloat(tax);
			}
			return payslip_other_deduction;
		},
		checkNum(value) {
			const num = parseFloat(value);
			return Number.isFinite(num) ? num : 0.00;
		},
		updateAll() {
			this.is_loading = true

			// emit event to collect all data from different components
			EventBus.$emit('collect-income-data')

			if (this.form.company_type && this.form.company_type != this.current_customer.companies.current?.company_type) {
				if (this.current_customer.companies.current) {
					this.current_customer.companies.current.company_type = this.form.company_type;
				}
				else {
					this.current_customer.companies.current = { "is_current": true, "company_type": this.form.company_type }
				}
				axios.post(services.customer + 'customer/' + this.current_customer.customer_id + '/companies', { companies: [this.current_customer.companies.current] }, { headers: getHeader() })
					.then(res => {
						this.notifySuccess('<b>Company Information: ' + this.current_customer.name + '</b> - Successfully Updated.')
						this.getCustomer(this.current_customer.customer_id)
					})
					.catch(e => {
						this.errorFunction(e)
					})
			}
			// add main parent data
			this.mainForm = Object.assign(this.mainForm, {
				income_type_id: this.form.income_type_id,
				income_earn_type_id: this.form.income_earn_type_id,
				monthly_salary: (this.isForeigIncome) ? _gHlp.currencyToRM(this.form.salary ?? 0, this.form.foreign_currency) : (this.form.salary ?? 0),
				fixed_allowance: (this.isForeigIncome) ? _gHlp.currencyToRM(this.form.fixed_allowance ?? 0, this.form.foreign_currency) : (this.form.fixed_allowance ?? 0),
				is_ex_epf_fa: this.form.epf_excluded_fa,
				working_country: this.form.working_country,
				foreign_currency: this.form.foreign_currency
			});

			axios.put(services.customer + 'customer/' + this.$route.params.customer_id + '/income.all', this.mainForm, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>Net Income: ' + this.current_customer.name + '</b> - Successfully Updated.')
					this.getCustomer(this.current_customer.customer_id)
					this.is_loading = false
				})
				.catch(e => {
					this.errorFunction(e)
					this.is_loading = false
				})
		},
		updateMainIncome() {
			let formData = {
				income_type_id: this.form.income_type_id,
				income_earn_type_id: this.form.income_earn_type_id,
				monthly_salary: (this.isForeigIncome) ? _gHlp.currencyToRM(this.form.salary ?? 0, this.form.foreign_currency) : (this.form.salary ?? 0),
				fixed_allowance: (this.isForeigIncome) ? _gHlp.currencyToRM(this.form.fixed_allowance ?? 0, this.form.foreign_currency) : (this.form.fixed_allowance ?? 0),
				is_ex_epf_fa: this.form.epf_excluded_fa,
				working_country: this.form.working_country,
				foreign_currency: this.form.foreign_currency
			}
			axios.put(services.customer + 'customer/' + this.current_customer.customer_id + '/income/main/' + this.current_customer.incomes.main.customer_main_income_id, formData, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>Net Income: ' + this.current_customer.name + '</b> - Successfully Updated.')
					this.getCustomer(this.current_customer.customer_id)
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
		viewDetails() {
			this.drawerViewNetIncomeDetails = !this.drawerViewNetIncomeDetails;
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		removeOther(item) {
			var index = this.dynamicOther.other.indexOf(item);
			if (index !== 0) {
				this.dynamicOther.other.splice(index, 1);
			}
		},
		addOther() {
			this.dynamicOther.other.push({
				key: Date.now(),
				income_amount: '',
				information: ''
			});
		},
		toggleDetailsModal() {
			this.modals.view_income_details = !this.modals.view_income_details;
		},
		selectIncome() {
			if (this.form.income_type_id === 3) {
				this.form.var_income = true;
			}
		}

	}
}
</script>